export enum Treatment {
  Self = 'self',
  SelfAndPartner = 'self+partner',
  Partner = 'partner',
}
